import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {BreadcrumbsItemModel} from "../../managers/breadcrumbs/breadcrumbs.item-model";
import {SCHEMA_TYPE} from "./consts";

export class BreadcrumbsListSchemaDataModel extends BaseSchemaDataModel {
  list: Array<BreadcrumbsItemModel>;
}

export class BreadcrumbsListSchemaModel extends BaseSchemaModel {
  model: BreadcrumbsListSchemaDataModel;

  constructor(model: BreadcrumbsListSchemaDataModel) {
    super(SCHEMA_TYPE.breadcrumbList);

    this.model = model;
  }

  get itemListElementParams(): String {
    let listItems: String = '';

    this.model.list.forEach((item: BreadcrumbsItemModel, index: Number) => {
      if(item.metaDataIncluded) {
        listItems += this.listItemToString(this.model.list, item, index)
      }
    });

    return this.model.list ? `,"itemListElement": [${listItems}]` : '';
  }

  toString(): String {
    return `${super.toString()}${this.itemListElementParams}`;
  }
}
